/* tslint:disable */

declare var Object: any;
export interface SFOvertimeRequestInterface {
  "id"?: number;
}

export class SFOvertimeRequest implements SFOvertimeRequestInterface {
  "id": number;
  constructor(data?: SFOvertimeRequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFOvertimeRequest`.
   */
  public static getModelName() {
    return "SFOvertimeRequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFOvertimeRequest for dynamic purposes.
  **/
  public static factory(data: SFOvertimeRequestInterface): SFOvertimeRequest{
    return new SFOvertimeRequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFOvertimeRequest',
      plural: 'SFOvertimeRequests',
      path: 'SFOvertimeRequests',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFOvertimeRequest.ts